module.exports = __webpack_public_path__ + "static/media/NHaasGroteskDSPro-95Blk.930b1469.ttf";